

<template>
  <div
    class="form-group"
    :class="className"
  >
    <label
      class="col-12 p-0"
      for="cycle-break"
    >{{ label }}</label>
    <vue-tel-input
      :value="value"
      type="number"
      :disabled="disabled"
      @onInput="onInput"
      disabledFetchingCountry
      :defaultCountry="defaultCountry"
    />
  </div>
</template>

<script>
import VueTelInput from 'vue-tel-input';
import { parsePhoneNumberFromString } from 'libphonenumber-js'

export default {
  name: 'VMobileInput',
  components: {
    VueTelInput
  },
  data() {
    return  {
      defaultCountry: '',
    }
  },
  props: {
    label: {
      type: String,
    },
    className: {
      type: Object,
      default: () => ''
    },
    value: {
      type: String,
      default: () => ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    countryCode: {
      type: String,
    }
  },
  beforeMount() {
    if (this.countryCode && this.value && parsePhoneNumberFromString(`+${this.countryCode}${this.value}`) && parsePhoneNumberFromString(`+${this.countryCode}${this.value}`).country) {
      this.defaultCountry = parsePhoneNumberFromString(`+${this.countryCode}${this.value}`).country;
    } else {
      this.defaultCountry = 'US';
    }
  },
  methods: {
    onInput(payload) {
      let mobileNumber = '';
       const splitNumberByCountryCode  = payload.number.split(`+${payload.country.dialCode}`);
       const splitNumberByPlusSymbol  = payload.number.split(`+`);
      if (splitNumberByCountryCode && splitNumberByCountryCode.length === 2) {
        mobileNumber = splitNumberByCountryCode[1].replace(/ /g, '');
      } else if (splitNumberByPlusSymbol && splitNumberByPlusSymbol.length ===  2) {
         mobileNumber = payload.number.replace(/ /g, '').slice(payload.number.split(' ')[0].length);
      }
      else {
       mobileNumber = payload.number;
      }

      this.$emit('onChange', payload , mobileNumber);
    },
  }
};
</script>

<style lang="scss" scoped>
  @import "./style.scss";
</style>

